import { i18n } from "discourse-i18n";

export default function userDisplayName(user) {
  if (!user?.name || user.name === user.username) {
    return user?.username;
  }

  return i18n("community_feedback.username_with_nickname", {
    nickname: user.name,
    username: user.username,
  });
}
